import React from "react";
import { useSelector } from "react-redux";

const Time = () => {

  const answeringInfo = useSelector( state => state.answeringInfo );

  return <div className="time">{ answeringInfo.displayTime }</div>;

};

export default Time;
